import { AnimalType } from '@app/models/chip.model';
import { CAT_BREEDS_COLLECTION } from '@app/pages/clinic/models/cat-breeds.data';
import { DOG_BREEDS } from '@app/pages/clinic/models/dog-breeds.data';

export function getBreedByTypeAndId(
    animalType: AnimalType | undefined,
    breedId: string | number | null | undefined,
): string {
    if (animalType === 'dog' && breedId) {
        return DOG_BREEDS.find((breed) => breed.id === +breedId)?.name || '';
    } else if (animalType === 'cat' && breedId) {
        return CAT_BREEDS_COLLECTION.find((breed) => breed.id === +breedId)?.name || '';
    }
    return '';
}
